import React, { useEffect, useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper,
  IconButton,
  styled,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { GREEN_LOGO, GREEN_MAIN } from '../theme/colors';
import { useTranslationContext } from '../hooks/translations/translationsProvider';
import { IBuy } from '../models/buy/Buy';
import { useWaiter } from '../hooks/waiter/WaiterProvider';
import { delay } from '../utilities/delay';
import { dashboard } from '../hooks/actions/dashboard';
import WithdrawMetamaskForm from './WithdrawMetamaskForm';
import WithdrawAssobayForm from './WithdrawAssobayForm';

const TabsCustom = styled(Tabs)(({theme})=>({
    minWidth: '105px',                                      
    [theme.breakpoints.up('xs')]: {
        maxWidth: '150px', 
    },
    "& .MuiTabs-indicator":{
        backgroundColor:"transparent",
        width: "0px"
    }
}))

const TabCustom = styled(Tab)(({theme})=>({
    fontSize:'10px',
    fontFamily: 'poppins', 
    color: GREEN_MAIN,
    padding:'9px',    
    textTransform: "none", 
    fontWeight:'normal',                                 
    [theme.breakpoints.up('sm')]: {
    },
    "&.Mui-selected": {
        color: GREEN_MAIN,
        fontWeight: "bold",
    },
}))

// ICONE E INFORMAZIONI DELLE TABS
const AssoBayLogo = <Box
  sx={{
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
<img src="/assoBayLogo.png" alt="AssoBay" width={'auto'} height={28} />
</Box>

const MetamaskLogo = <Box
  sx={{
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <img src="/metamask.png" alt="Metamask" width={28} height={28} />
</Box>


const withdrawMethods = [
    { 
        label: '', 
        value: 'assobay', 
        ico: AssoBayLogo, 
        type: 1,
        title: "Trasferisci ASSO al tuo account Assobay",
        enabled: true, 
    },
    // { 
    //     label: 'Metamask', 
    //     value: 'bankTransfer', 
    //     ico: MetamaskLogo, 
    //     type: 0, 
    //     title: "Preleva con portafogli elettronico",
    //     enabled: true,
    // },
];

interface WithdrawTypeFormProps {
    setTitle:React.Dispatch<React.SetStateAction<string>>
}

const WithdrawTypeForm: React.FC<WithdrawTypeFormProps> = ({setTitle}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [response, setResponse] = useState<IBuy | null>(null);
    const {t} = useTranslationContext();
    
    // CONTROVALORE GENERALE (EUR, BITCOIN ecc..)
    const [amount, setAmount] = useState('');
    
    // ASSO
    const [amountAvaiable, setAmountAvaible] = useState<number>(0);
    const [statusResponse, setStatusResponse] = React.useState<boolean>(false)
    // FINE ASSO

    const {setWaiterView} = useWaiter();

    useEffect(()=>{
        setWaiterView(true)
        delay(500).finally(()=>{
            dashboard()
                .then(resp => {
                    setAmountAvaible(resp.balance)
                })
                .catch(error => {
                    // initLoad.current = false
                    console.log(error)
                })
            setWaiterView(false)
        })
    },[])

    useEffect(()=>{
        setTitle(withdrawMethods[selectedTab].title);
    },
    [selectedTab, withdrawMethods])

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
        setAmount("");
    };

    useEffect(()=>{
        setResponse(null);
    },[selectedTab])

    return (
        <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins'}}>
            <Paper sx={{ 
                width: '100%', 
                display: 'flex', 
                minHeight: '350px', 
                border: 1, 
                borderColor: 'transparent',  
                overflow: 'hidden',
                maxWidth: '100%', // Limita la larghezza massima del Paper
                boxSizing: 'border-box',
            }}>
                <TabsCustom
                    orientation="vertical"
                    variant="scrollable"
                    value={selectedTab}
                    onChange={handleTabChange}
                    sx={{ borderRight: 2, borderColor: `${GREEN_LOGO}30` }}
                >
                    {withdrawMethods.map((method, index) => (
                        <TabCustom
                            key={index}
                            icon={ method.ico}
                            label={t(method.label)}
                            sx={{ 
                                borderBottom: 1, 
                                borderColor: 'transparent' 
                            }}
                        />
                    ))}
                </TabsCustom>
                <Box sx={{ flexGrow: 1, p: 3, position: 'relative', maxWidth: '100%', boxSizing: 'border-box' }}>
                    {response && (
                        <IconButton
                            onClick={() => window.print()}
                            sx={{ position: 'absolute', top: 16, right: 16 }}
                        >
                            <PrintIcon />
                        </IconButton>
                    )}

                    <Card sx={{ backgroundColor: 'transparent', boxShadow: 'none', }}>
                        <CardContent 
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                //padding: '24px 0 0 0',
                                flexDirection: 'column',
                                maxWidth: '100%', // Limita il contenuto a non superare il suo contenitore
                                boxSizing: 'border-box',
                        }}>
                            { !response &&
                                <Grid container spacing={2} justifyContent={'center'} sx={{maxWidth: '100%', boxSizing: 'border-box' }}>
                                    <Grid item xs={12}>
                                    {
                                        withdrawMethods[selectedTab].type === 0 && // metamask
                                        (withdrawMethods[selectedTab].enabled ? 
                                            <Box>
                                                <WithdrawMetamaskForm status={statusResponse} setStatus={setStatusResponse}/>
                                            </Box> : 
                                            <Typography>
                                                {t("Tipologia di acquisto non ancora disponibile")}
                                            </Typography>
                                        )      
                                    }
                                    {
                                        withdrawMethods[selectedTab].type === 1 && // assobay
                                        (withdrawMethods[selectedTab].enabled ? 
                                            <Box>
                                                <WithdrawAssobayForm status={statusResponse} setStatus={setStatusResponse}/>
                                            </Box> : 
                                            <Typography>
                                                {t("Tipologia di acquisto non ancora disponibile")}
                                            </Typography>
                                        )      
                                    }
                                    </Grid>

                                </Grid>
                            }

                            
                        </CardContent>
                    </Card>
                </Box>
            </Paper>
        </Box>
    );
};

export default WithdrawTypeForm;
